module.exports = __webpack_public_path__ + "media/images/lupa_xxx-7e3f70bad34463e1538219d4ea857dc6.svg";